import React, { useState } from 'react';
import { copyToClipboard } from '../utils/clipboard';

interface CopyButtonProps {
  value: string;
  label?: string;
  className?: string;
  small?: boolean;
}

const CopyButton: React.FC<CopyButtonProps> = ({ value, label = 'Copy', className = '', small = false }) => {
  const [copied, setCopied] = useState(false);

  const handle = async () => {
    const ok = await copyToClipboard(value);
    if (ok) {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    }
  };

  const base = small
    ? 'px-2 py-1 text-xs'
    : 'px-3 py-1.5 text-xs';

  return (
    <button
      type="button"
      onClick={handle}
      className={`${base} font-medium rounded-lg transition-all ${
        copied
          ? 'text-emerald-300 bg-emerald-500/10 hover:bg-emerald-500/20'
          : 'text-indigo-400 hover:text-indigo-300 bg-indigo-500/10 hover:bg-indigo-500/20'
      } ${className}`}
    >
      {copied ? 'Copied' : label}
    </button>
  );
};

export default CopyButton;
